<template>
  <SecurityBody/>
</template>

<script>
// @ is an alias to /src
import SecurityBody from '@/components/SecurityBody.vue'

export default {
  name: 'SecurityView',
  components: {
    SecurityBody
  }
}
</script>
